import _readOnlyError from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/readOnlyError.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import empty from '../empty.vue';
export default {
  name: 'foods_brands',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    empty: empty
  },
  computed: {
    site_image_open: function site_image_open() {
      // 兼容老数据没有该属性
      var _this$value$config$si = this.value.config.site_image_open,
        site_image_open = _this$value$config$si === void 0 ? 1 : _this$value$config$si;
      return site_image_open;
    },
    brandList: function brandList() {
      return this.value.config.value.filter(function (i) {
        return i.flag;
      });
    }
  }
};